/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable complexity */

import React, {
	useEffect, useState,
} from 'react';
import { useForm } from 'react-hook-form';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import {
	changePaymentOption, ccCreateTransaction, payRequestCancel, setOpenRequestDataAC, changeNumberOfPaymentsAC,
} from '../../../redux/payment-details-reducer.js';
import Error from '../error/error.jsx';
import Field from '../Field.js';
import Popup from '../popup/Popup.js';
import PaymentButton from '../PaymentButton.js';
import chevron from '../../../images/chevron.svg';
import numberWithCommas from '../../../utils/numberWithCommas.js';
import fillSelectOptions from '../../../utils/fillSelectOptions.js';
import bit from '../../../images/bit.svg';
import paymentsMenu from '../../../images/credit_card_icon.png';

export function isValidIsraeliID(rawId) {
	const id = String(rawId).trim();
	if (id.length < 5 || id.length > 9 || _.isNaN(id)) {
		return false;
	}

	const padded = id.padStart(9, '0');
	const digits = _.map(padded, Number);
	const sum = _.sum(_.map(digits, (digit, i) => {
		const step = digit * ((i % 2) + 1);
		return step > 9 ? step - 9 : step;
	}));
	return sum % 10 === 0;
}

const prefixes = [
	'050',
	'051',
	'052',
	'053',
	'054',
	'055',
	'056',
	'057',
	'058',
];

/**
	*
	*/
function Home() {
	const paymentDetails = useSelector(({ paymentDetails }) => paymentDetails);
	const [isOpenRequest, setIsOpenRequest] = useState(null);
	const [paymentMethod, setPaymentMethod] = useState(null);

	const dispatch = useDispatch();
	const [cardMethodChozen, setCardMethodChozen] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [iframeContainer, setIframeContainer] = useState(null);
	const [iframeKey, setiframeKey] = useState(0);

	const form = useForm();
	const { formState: { errors } } = form;

	useEffect(() => {
		setIsOpenRequest(paymentDetails.isOpenSum || paymentDetails.isOpenContact);
	}, [paymentDetails.isOpenContact, paymentDetails.isOpenSum]);

	useEffect(() => {
		if (paymentDetails.isOpenSum) {
			form.register('sum', { required: true, validate: v => Number(v.replaceAll(',', '')) <= 10_000_000 });
		}

		if (paymentDetails.isOpenContact) {
			form.register('name', { required: true });
			form.register('lastName', { required: false });
			form.register('phone', { required: true, minLength: 7, maxLength: 7 });
			form.register('prefix', { required: true });
		}

		if ((paymentDetails.numOfPayments && paymentDetails.numOfPayments > 1) || (paymentDetails.isOpenSum && !paymentDetails.numOfPayments)) {
			form.register('numOfPayments', { required: false });
		}

		form.register('invoicePayerName', {
			required: isAllocationNumberRequired() && 'יש להזין שם המוטב',
		});

		form.register('invoicePayerIdentifier', {
			required: isAllocationNumberRequired() && 'לקוח יקר, יש להזין מספר ח.פ./ת.ז. תקין.',
			validate: v => isValidIsraeliID(v) || 'לקוח יקר, יש להזין מספר ח.פ./ת.ז. תקין.',
		});
	}, [form.register, paymentDetails.isOpenContact, paymentDetails.numOfPayments, paymentDetails.isOpenSum]);

	useEffect(() => {
		form.setValue('numOfPayments', '1');
	}, []);

	useEffect(() => {
		if (paymentDetails.WEB_BIT_JS_BUNDLE) {
			const script = document.createElement('script');
			script.src = paymentDetails.WEB_BIT_JS_BUNDLE;
			script.async = true;
			document.body.append(script);
		}
	}, [paymentDetails.WEB_BIT_JS_BUNDLE]);

	useEffect(() => {
		if (paymentDetails.sessionId) {
			gamapayInit(paymentDetails.sessionId);
		}
	}, [paymentDetails.sessionId]);

	useEffect(() => {
		const pciOnMessage = ({ data }) => {
			if (data === 'stepBack') {
				setCardMethodChozen(false);
			} else {
				dispatch(ccCreateTransaction(data));
			}
		};

		if (window.addEventListener) {
			window.addEventListener('message', pciOnMessage, false);
		} else if (window.attachEvent) {
			window.attachEvent('onmessage', pciOnMessage, false);
		}
	}, [dispatch]);

	useEffect(() => {
		if (paymentDetails.errorsHome.length <= 0) {
			return;
		}

		setiframeKey(iframeKey + 1);
	}, [paymentDetails.errorsHome]);

	useEffect(() => {
		form.clearErrors('invoicePayerName');
		form.clearErrors('invoicePayerIdentifier');
	}, [form.watch().sum]);

	const payerDetails = {
		payerName: paymentDetails.isOpenContact ? form.watch().name : paymentDetails.payerName,
		lastName: paymentDetails.isOpenContact ? form.watch().lastName : paymentDetails.payerLastName,
		paymentFor: paymentDetails.paymentFor,
		paymentAmount: paymentDetails.isOpenSum ? form.watch().sum?.replace(/,/g, '') : paymentDetails.paymentAmount,
		phonePrefix: form.watch().prefix ?? '',
		phone: form.watch().phone ?? '',
		email: form.watch().email ?? '',
		orderId: paymentDetails.orderId,
		numOfPayments: form.watch().numOfPayments,
		invoicePayerName: paymentDetails.isOpenContact ? form.watch().invoicePayerName : paymentDetails.invoicePayerName,
		invoicePayerIdentifier: paymentDetails.isOpenContact ? form.watch().invoicePayerIdentifier : paymentDetails.invoicePayerIdentifier,
	};

	const _cancelRequest = () => {
		// eslint-disable-next-line no-alert
		if (!window.confirm('האם לבטל את בקשת התשלום?')) {
			return;
		}

		dispatch(payRequestCancel());
	};

	const fieldsValidation = () => {
		let errors = 0;

		if (!paymentDetails.isOpenContact && paymentMethod) {
			return 0;
		}

		const array = [];
		if (paymentDetails.isOpenContact) {
			array.push('name', 'phone', 'prefix');
		}

		if (paymentDetails.isOpenSum) {
			array.push('sum');
		}

		if (paymentDetails.isOpenSum) {
			const sumWithoutCommas = form.watch().sum?.replaceAll(',', '');
			const numberOfPayments = form.watch().numOfPayments;
			if (Boolean(sumWithoutCommas) && (Number(sumWithoutCommas) < 1 || Number.isNaN(sumWithoutCommas))) {
				form.setError('sum', { message: 'הסכום לתשלום חייב להיות גדול או שווה ל-1' });
				errors++;
			} else if (Boolean(sumWithoutCommas) && Number(sumWithoutCommas) > 10_000_000) {
				form.setError('sum', { message: 'לא ניתן להזין סכום גבוה מ- 10,000,000' });
				errors++;
			}

			if (numberOfPayments) {
				const MIN_SINGLE_PAYMENT = 1;
				const singlePaymentSum = Number(sumWithoutCommas) / Number(numberOfPayments);
				if (singlePaymentSum < MIN_SINGLE_PAYMENT) {
					form.setError('numOfPayments', { message: `עבור עסקת תשלומים גובה כל תשלום לא יקטן מ ${MIN_SINGLE_PAYMENT} ש"ח` });
					errors++;
				}
			}
		}

		const emptyFieldsLength = array.filter(element => {
			if (!form.watch()[element]) {
				form.setError(element, {});
				return element;
			}

			return false;
		});

		if (isAllocationNumberRequired()) {
			if (!form.watch().invoicePayerName) {
				form.setError('invoicePayerName', { message: 'יש להזין שם המוטב' });
				errors++;
			}

			if (!isValidIsraeliID(form.watch().invoicePayerIdentifier)) {
				form.setError('invoicePayerIdentifier', { message: 'לקוח יקר, יש להזין מספר ח.פ./ת.ז. תקין.' });
				errors++;
			}
		}

		return errors + emptyFieldsLength.length;
	};

	const nextFunction = () => {
		if (fieldsValidation() > 0) {
			return false;
		}

		if (paymentMethod === 'bit') {
			submitBit();
		} else if (paymentMethod === 'card') {
			submitCC();
			sendDataToIframe({
				action: 'init',
				payload: {
					sum: form.watch().sum?.replaceAll(',', ''),
					email: form.watch().email,
				},
			});
		}
	};

	const submitBit = () => {
		if (isOpenRequest === true) {
			setShowModal(false);
			setErrorMessage('');
			form.clearErrors();

			dispatch(setOpenRequestDataAC(payerDetails));
			dispatch(changePaymentOption('bit', payerDetails, true));
			dispatch(changeNumberOfPaymentsAC(form.watch().numOfPayments));
			return;
		}

		setShowModal(false);
		dispatch(changePaymentOption('bit', payerDetails));
		dispatch(changeNumberOfPaymentsAC(form.watch().numOfPayments));
	};

	const submitCC = () => {
		if (isOpenRequest === true) {
			setErrorMessage('');
			form.clearErrors();
			dispatch(changeNumberOfPaymentsAC(form.watch().numOfPayments));
			dispatch(setOpenRequestDataAC(payerDetails));
			if (!paymentDetails.isFetching) {
				dispatch(changePaymentOption('card', payerDetails, true));
			}

			setCardMethodChozen(true);
			return;
		}

		dispatch(changeNumberOfPaymentsAC(form.watch().numOfPayments));
		if (!paymentDetails.isFetching) {
			dispatch(changePaymentOption('card'));
		}

		setCardMethodChozen(true);
	};

	const showErrorPopupFunction = (currentNumberOfPayment, numberOfPayments, paymentMethod, callback = () => null) => {
		if (numberOfPayments <= 1) {
			callback();
			return;
		}

		if (paymentMethod === 'bit' && currentNumberOfPayment > 1) {
			setShowModal(true);
			return;
		}

		callback();
	};

	const mapIdToMethod = {
		1: {
			name: 'bit',
			img: bit,
			onClick: () => showErrorPopupFunction(form.watch().numOfPayments, paymentDetails.numOfPayments, 'bit', setPaymentMethod('bit')),
		},
		2: {
			name: 'card',
			img: paymentsMenu,
			onClick: () => showErrorPopupFunction(form.watch().numOfPayments, paymentDetails.numOfPayments, 'card', setPaymentMethod('card')),
		},
	};

	if (paymentDetails.confirmationNumber) {
		return <Redirect to={paymentDetails.paymentOption === 'card' ? `/success?paymentOption=card&confirmationNumber=${paymentDetails.confirmationNumber}` : '/success'} />;
	}

	if (paymentDetails.deleted) {
		return <div className='mt-5 alert alert-success'>בקשת התשלום בוטלה בהצלחה!</div>;
	}

	return (
		<div className='home' ref={setIframeContainer}>
			{
				paymentDetails.errorsHome.length > 0
				&& <Error>
					{paymentDetails.errorsHome.map((element, ind) => (
						<div key={element.msg}>
							{element.msg}
						</div>
					))}
				</Error>
			}
			{errorMessage && <Error> {errorMessage} </Error>}
			{cardMethodChozen && <iframe
				key={iframeKey}
				height={_.toNumber(iframeContainer?.clientHeight)}
				className='pci-iframe'
				title='cardPayment'
				src={`${paymentDetails.WEB_PCI_BASE_URL}?ptoken=${paymentDetails.Ptoken}`}
			/>}
			{paymentDetails.paymentAmount && !cardMethodChozen && paymentDetails.errorsHome.length <= 0
				&& <><div className='home__top'>
					<div className='home__top__title'>
						<strong>שלום{paymentDetails.payerName && paymentDetails.payerName !== 'undefined' ? ` ${paymentDetails.payerName}` : ''}{paymentDetails.payerLastName && paymentDetails.payerLastName !== 'undefined' ? ` ${paymentDetails.payerLastName}` : ''},</strong>
						<div>קיבלת בקשת תשלום</div>
					</div>
					<hr className='d-md-none' />
					<div className='home__top__text'>
						{paymentDetails.sender && (<div>מ: {paymentDetails.sender}</div>)}
						<div className='home__top__descr'>עבור: {paymentDetails.paymentFor} </div>
						{paymentDetails.isOpenSum
							? <div className='d-flex align-items-center open_sum'>
								<div className='ms-3'>סכום לבחירתך: </div>
								<Field
									required
									name='sum'
									type='tel'
									label='סכום'
									value={form.watch().sum}
									setValue={form.setValue}
									errors={errors}
									trigger={form.trigger}
									setErrMsg={setErrorMessage}
								/>
							</div>
							: <div>סכום: {numberWithCommas(paymentDetails.paymentAmount)} ש״ח</div>}
						{paymentDetails.invoicePayerName && <div>שם המוטב: {paymentDetails.invoicePayerName}</div>}
						{paymentDetails.invoicePayerIdentifier && <div>מספר ח.פ./ת.ז. המוטב: {paymentDetails.invoicePayerIdentifier}</div>}
					</div>
				</div>
					<hr />
					<div className='home__bottom'>
						{paymentDetails.isOpenContact && <>
							<div className='row'>
								<div className='col-6 col-lg-3 mb-3 name'>
									<Field
										required
										name='name'
										label='שם פרטי'
										value={form.watch().name}
										setValue={form.setValue}
										errors={errors}
										trigger={form.trigger}
										setErrMsg={setErrorMessage}
									/>
								</div>
								<div className='col-6 col-lg-3 mb-3 lastName'>
									<Field
										name='lastName'
										label='שם משפחה'
										value={form.watch().lastName}
										setValue={form.setValue}
										errors={errors}
										trigger={form.trigger}
										required={false}
										setErrMsg={setErrorMessage}
									/>
								</div>
							</div>
							<div className='row mt-3'>
								<div className='col-8 col-lg-4 phone'>
									<Field
										required
										isPhone
										name='phone'
										type='tel'
										value={form.watch().phone}
										label='מספר נייד'
										setValue={form.setValue}
										errors={errors}
										trigger={form.trigger}
										maxLength={7}
									/>
								</div>
								<div className='col-4 col-lg-2 prefix'>
									<Field
										required
										name='prefix'
										value={form.watch().prefix}
										maxLength={7}
										setValue={form.setValue}
										type='select'
										errors={errors}
										options={['', ...prefixes]}
										trigger={form.trigger}
									/>
								</div>
							</div>
							<div className='row mt-3'>
								<div className='col-8 col-lg-6 mt-3 mb-3 email'>
									<Field
										name='email'
										type='text'
										value={form.watch().email}
										label='כתובת דוא״ל'
										required={false}
										setValue={form.setValue}
										errors={errors}
										trigger={form.trigger}
									/>
								</div>
							</div>
							<div className='row mt-3'>
								<div className='col-8 col-lg-6 mt-3 mb-3'>
									<Field
										required={isAllocationNumberRequired()}
										name='invoicePayerName'
										label='שם המוטב'
										value={form.watch().invoicePayerName}
										setValue={form.setValue}
										errors={errors}
										trigger={form.trigger}
										setErrMsg={setErrorMessage}
									/>
								</div>
							</div>
							<div className='row mt-3'>
								<div className='col-8 col-lg-6 mt-3 mb-3'>
									<Field
										required={isAllocationNumberRequired()}
										name='invoicePayerIdentifier'
										label='מספר ח.פ./ת.ז. המוטב'
										value={form.watch().invoicePayerIdentifier}
										setValue={form.setValue}
										errors={errors}
										trigger={form.trigger}
										setErrMsg={setErrorMessage}
									/>
								</div>
							</div>
						</>}
						<div className='home__bottom__text mt-3'>
							<div>לחצו על אופן התשלום כדי להמשיך</div>
						</div>
						<div className='home__bottom__images d-flex'>
							{paymentDetails.paymentMethods && paymentDetails.paymentMethods.map(({ Value, Decscription }) => (
								<PaymentButton
									key={Value}
									id={Value}
									title={Decscription}
									item={mapIdToMethod[Value]}
									isFetching={mapIdToMethod[Value].name === 'bit' && paymentDetails.isFetching}
									activeMethod={paymentMethod} />
							))}
						</div>
						{((paymentDetails.numOfPayments && paymentDetails.numOfPayments > 1) || (paymentDetails.isOpenSum && !paymentDetails.numOfPayments)) && <div className='d-flex align-items-center mt-3'>
							<div id='numOfPaymentsText' className='ms-3'>מספר תשלומים: </div>
							<Field
								required
								name='numOfPayments'
								value={form.watch().numOfPayments}
								setValue={form.setValue}
								numOfPayments={paymentDetails.numOfPayments}
								paymentMethod={paymentMethod}
								showErrorPopupFunc={showErrorPopupFunction}
								type='select'
								errors={errors}
								options={paymentDetails.numOfPayments ? fillSelectOptions(paymentDetails.numOfPayments) : fillSelectOptions(12)}
								trigger={form.trigger}
							/>
						</div>}
						<div className='d-flex flex-md-column flex-column-reverse mt-3'>
							<div className='home__bottom__text'>
								<div>
									{
										!paymentDetails.isOpenContact &&
										<>במידה וקיבלת את הבקשה בטעות עליך ללחוץ על "ביטול".
											< br /></>
									}
									התשלום מבוצע בהתאם לתקן אבטחה מחמיר PCI.
								</div>
							</div>
							<hr className='d-md-none' />
							<div className='home__bottom__cancel mt-4'>
								{
									!paymentDetails.isOpenContact &&
									<button className='btn btn-link' type='button' onClick={_cancelRequest}>ביטול</button>
								}
								<Button disabled={_.isNil(paymentMethod)} className='yellow_button d-flex align-items-center' onClick={() => showErrorPopupFunction(form.watch().numOfPayments, paymentDetails.numOfPayments, paymentMethod, () => nextFunction())}>
									<div>
										לתשלום
									</div>
									<div className='d-flex arrow'>
										<img src={chevron} alt='<' />
									</div>
								</Button>
							</div>
						</div>
					</div>
				</>}
			<Popup showModal={showModal} setShowModal={setShowModal} confirmFunc={() => [setShowModal(false), form.setValue('numOfPayments', 1)]} />
		</div>
	);

	function sendDataToIframe(data) {
		const iframe = document.querySelector('.pci-iframe');
		iframe?.contentWindow.postMessage(data);
	}

	function isAllocationNumberRequired() {
		if (paymentDetails.allowedForAllocationNumber !== 'true') {
			return false;
		}

		if (paymentDetails.isOpenSum) {
			return Number(form.watch().sum?.replaceAll(',', '')) > Number(paymentDetails.sumForAllocationNumber);
		}

		return Number(paymentDetails.paymentAmount) > Number(paymentDetails.sumForAllocationNumber);
	}
}

export default Home;
